import * as Text from './main';
export { Text };
//# sourceMappingURL=index.js.map